import Model from '@/models/Model.js';

export default class QuizActivity extends Model {
    static entity = 'quiz_activities';

    static modelName = 'QuizActivity';

    static fields() {
        return {
            review_allowed: this.attr(null),
            show_answers_in_review: this.attr(null),
            show_provided_answers_in_review: this.attr(null),
            show_correct_answers_in_review: this.attr(null),
            show_score_in_review: this.attr(null),
            time_limit: this.attr(null),
            lockdown: this.attr(null),
            password: this.attr(null),
            password_enabled: this.attr(null),
            quiz_version_id: this.attr(null),
            force_start: this.attr(null),
            calculator_enabled: this.attr(null),
            quiz: this.belongsTo('quizzes', 'quiz_version_id'),
        };
    }
}
